<template>
  <div class="drawer__content">
    <div class="drawer__content__head">
      <div class="button-group">
        <button
          class="button u-pos-r"
          @click.prevent="$store.dispatch('drawer/close')"
        >
          <i class="icon icon-e-remove" />
        </button>
      </div>
    </div>
    <div class="drawer__content__body">
      <div class="drawer__content__heading">
        <h4>Notifications</h4>
      </div>
      <div class="notifications">
        <div class="notifications__list">
          <div class="notifications__item">
            <div class="notifications__icon">
              <i class="icon icon-flag-diagonal-34" />
            </div>
            <div class="notifications__details">
              <div class="data-group data-group--v">
                <span class="data data--highlight">This is flagging</span>
                <span class="data data--muted">Excepteur sint occaecat cupidatat sint occaecat non...</span>
              </div>
            </div>
          </div>
          <div class="notifications__item">
            <div class="notifications__icon">
              <i class="icon icon-notification-2" />
            </div>
            <div class="notifications__details">
              <div class="data-group data-group--v">
                <span class="data data--highlight">This is from admin</span>
                <span class="data data--muted">Excepteur sint occaecat cupidatat sint occaecat non...</span>
              </div>
            </div>
          </div>
          <div class="notifications__item">
            <div class="notifications__icon">
              <i class="icon icon-speaker" />
            </div>
            <div class="notifications__details">
              <div class="data-group data-group--v">
                <span class="data data--highlight">This is announcement</span>
                <span class="data data--muted">Excepteur sint occaecat cupidatat sint occaecat non...</span>
              </div>
            </div>
          </div>
          <div class="notifications__item">
            <div class="notifications__icon">
              <i class="icon icon-t-warning" />
            </div>
            <div class="notifications__details">
              <div class="data-group data-group--v">
                <span class="data data--highlight">This is a warning</span>
                <span class="data data--muted">Excepteur sint occaecat cupidatat sint occaecat non...</span>
              </div>
            </div>
          </div>
          <div class="notifications__item">
            <div class="notifications__icon">
              <i class="icon icon-time-alarm" />
            </div>
            <div class="notifications__details">
              <div class="data-group data-group--v">
                <span class="data data--highlight">This is a reminder</span>
                <span class="data data--muted">Excepteur sint occaecat cupidatat sint occaecat non...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="user-settings">
    <div class="user-settings__head">
      <div class="button-group">
        <button
          class="button u-pos-r"
          @click.prevent="$store.dispatch('drawer/close')"
        >
          <i class="icon icon-e-remove" />
        </button>
      </div>
      <div class="avatar avatar--circle">
        <img src="/img/avatar-18.jpg">
      </div>
      <div class="data-group data-group--v">
        <span class="data data--highlight">{{ $page.props.auth.user.display_name }}</span>
        <span class="data data--muted">Administratorsss</span>
        <span class="data data--muted">Third Line</span>
      </div>
    </div>
    <div class="user-settings__body">
      <div class="navlinks navlinks--v">
        <div class="navlinks__item">
          <a href="" class="navlinks__link">
            <span class="navlinks__icon">
              <i class="icon icon-pen-2" />
            </span>
            <span class="navlinks__label">Edit Profile</span>
          </a>
        </div>
        <div class="navlinks__item">
          <a href="" class="navlinks__link">
            <span class="navlinks__icon">
              <i class="icon icon-a-security" />
            </span>
            <span class="navlinks__label">Change Password</span>
          </a>
        </div>
        <div class="navlinks__item">
          <a href="" class="navlinks__link">
            <span class="navlinks__icon">
              <i class="icon icon-c-question" />
            </span>
            <span class="navlinks__label">Online Help</span>
          </a>
        </div>
        <div class="navlinks__item">
          <inertia-link
            class="navlinks__link"
            href="/logout"
            method="post"
          >
            <span class="navlinks__icon">
              <i class="icon icon-leave" />
            </span>
            <span class="navlinks__label">Logout</span>
          </inertia-link>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
// import ProfileSettingsDrawer from '@components/drawers/ProfileSettingsDrawer'

export default {
  methods: {
    openProfileSettings () {
      this.$store.dispatch('drawer/close')

      // this.$store.dispatch('drawer/open', {
      //   drawer: ProfileSettingsDrawer,
      //   left: false,
      // })
    },
  },
}
</script>
